export default {
  image: 'A4_1.png',
  pdf: '220922_WA-HWF_008_A4_1_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-HWF-008',
    technicalValues: {
      soundReductionIndex: {
        output: '50,9',
        value: 50.9
      },
      heatTransferCoefficient: {
        output: '0,20',
        value: 0.2
      },
      fireBehavior: {
        output: 'normalentflammbar (B2)',
        value: 'B2'
      },
      fireResistanceOuter: {
        output: 'F 90-B',
        value: 'F-90-B'
      },
      fireResistanceInner: {
        output: 'F 30-B',
        value: 'F-30-B'
      }
    },
    name: 'Wandaufbau mit Holzweichfaser l Aufbau 8',
    construction: {
      composition: [
        {
          output: 'mineralischer Unterputz',
          type: 'render',
          title: { de: 'Putz' },
          value: 'min-1'
        },
        {
          output: '60 mm Sto-Weichfaserplatte M046',
          type: 'pinsulation',
          title: { de: 'Dämmung' },
          value: 'wmo46-60'
        },
        {
          output: 'ohne',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: null
        },
        {
          output: '60/140',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-140'
        },
        {
          output: '140 mm Steinwolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cirw-140'
        },
        {
          output: '15 mm OSB-Platte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'ib-15'
        },
        {
          output: '9,5 mm Gipskartonplatte',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: 'im-9'
        }, 
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '231,5',
        value: 231.5
      }
    }
  }
}
